
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'


export interface StatusState {
  isLoading: boolean,
  isLoadingChanges: boolean,
  isLoadingAuth: boolean,
  error?: string;
  success?: string;
  isLoadingfilter?: boolean;
  isLoadingPdf?: boolean;
}

const initialState: StatusState = {
  isLoading: false,
  isLoadingChanges: false,
  isLoadingAuth: true,
  isLoadingfilter: false,
  isLoadingPdf: false,
}
export const statusSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },

    setErrorMess: (state,  action: PayloadAction<any>) => {
        state.error = state.error =   action.payload?.detail || action.payload?.message || action.payload?.error || action.payload || "Unknown error"

    },
    setSuccessMess: (state, action: PayloadAction<string | undefined>) => {
      state.success = action.payload
    },
    clearErrorMess: (state, action: PayloadAction<string | undefined>) => {
      state.error = action.payload
    },
    setLoadingChanges: (state, action: PayloadAction<boolean>) => {
      state.isLoadingChanges = action.payload
    },
    setLoadingAuth: (state, action: PayloadAction<boolean>) => {
      state.isLoadingAuth = action.payload
    },
    setLoadingFilter: (state, action: PayloadAction<boolean>) => {
      state.isLoadingfilter = action.payload
    },
    setLoadingPdf: (state, action: PayloadAction<boolean>) => {
      state.isLoadingPdf = action.payload
    },
  },
})

export const { setLoading, setErrorMess, setSuccessMess, clearErrorMess, setLoadingChanges, setLoadingAuth, setLoadingFilter, setLoadingPdf } = statusSlice.actions
export default statusSlice.reducer
